/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Card, Row, Col, Badge, Modal } from 'antd';
import Img from "react-image";
import { getTranslate } from "react-localize-redux";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getProductDiscounts, openOrCloseDiscountDetailsModal } from "../../reducers/discounts";
import placeholderImg from "assets/img/banner-placeholder.png";
import NoData from "components/reusable/NoData";
import { Spinner } from "components/Spinner";
import DiscountDetails from "./DiscountDetails";
import { ImageLoader } from "components/Spinner";
import Constants from "utilities/appConstants";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Meta } = Card;

/* Get the noSchemeImageBannerColorSequence from global window object */
const { noSchemeImageBannerColorSequence } = window;

/* Const,Let & Var will be here */

class DiscountList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDisc: null,
      isMobileView: window.innerWidth <= 992 ? true : false
    }

    /* Get selected product mapped discount list */
    this.getProductDiscountList();
  }

  getProductDiscountList = () => {
    this.props.actions.getProductDiscounts(this.props.productId);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.productId !== undefined && this.props.productId !== prevProps.productId) {
      /* Get the discount list */
      this.getProductDiscountList();
    }
  }

  showDiscountDetails = (discount) => {
    this.setState({ selectedDisc: discount });
    this.props.actions.openOrCloseDiscountDetailsModal(true);
  }

  closePromoDetails = () => {
    this.setState({ selectedDisc: null });
    this.props.actions.openOrCloseDiscountDetailsModal(false);
  }

  /* Get scheme image */
  getSchemeCover = (scheme, index) => {
    if (scheme.ImageUrl && scheme.ImageUrl !== "") {
      return (
        <Img
          className="promotion-card-image-fit" alt=""
          src={[scheme.ImageUrl, placeholderImg]}
          loader={<ImageLoader />}
        />
      );
    }
    else {
      return (
        <div
          className="promotion-card-image-fit promotion-color-banner overflow-auto"
          style={{ "backgroundColor": this.getBackgroundColor(index) }}>
          <h6 className="banner-text-truncate scheme-image-scheme-name">{scheme.Desc}</h6>
        </div >
      );
    }
  }

  /* Get dynamic background color for discount banner */
  getBackgroundColor = (index) => {
    return index % 2 === 0
      ? noSchemeImageBannerColorSequence[1]
      : noSchemeImageBannerColorSequence[0];
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ isMobileView: window.innerWidth <= 992 ? true : false });
  }

  /* Display only 4 discounts in mobile view and 6 discounts in web view in the offer zone - home page */
  getDiscountArrayBasedOnPageType = () => {
    return this.props.discounts.discountList;
  }

  renderComp = () => {
    const { translate, requestPageType, discounts } = this.props;

    if (discounts.isLoading && discounts.discountList.length === 0) {
      return (
        <div className="container pt-5">
          <Spinner message={translate("discount.loading.discountList")} />
        </div>
      );
    }
    else if (discounts.discountList.length > 0) {
      return (
        <React.Fragment>
          <div className={classNames('container', { 'pl-0 pr-0 mt-2': (requestPageType === Constants.PRODUCT_DETAILS) })}>
            <Row>
              {this.getDiscountArrayBasedOnPageType().map((discount, index) => (
                <Col xs={12}
                  sm={12}
                  md={12}
                  lg={8}
                  xl={8}
                  className="pt-2 pr-2 pl-2 p-2"
                  key={discount.DiscountId}
                  onClick={() => this.showDiscountDetails(discount)}
                >
                  <Badge.Ribbon text={translate("products.productLabel.discountRibbon")} color="#4CAF50" placement="start">
                    <Card
                      className="promotion-card-shadow promo-list-card"
                      hoverable
                      cover={
                        <div className="promotion-card-image-fit">
                          {this.getSchemeCover(discount, index)}
                        </div>
                      }
                    >
                      <Meta className="scheme-name-wrap-three-line" title={discount.Desc} />

                      <Row gutter={[8, 8]} className="responsive-font-size">
                        <Col span={24} md={12}>
                          <Badge status="success" />
                          {translate("promotion.start")} : {discount.StartDate}</Col>
                        <Col span={24} md={12}>
                          <Badge status="error" />
                          {translate("promotion.end")} : {discount.EndDate}</Col>
                      </Row>
                    </Card>
                  </Badge.Ribbon>
                </Col>
              ))}
            </Row>
          </div>

          {/* Discount Details Modal */}
          {this.props.discounts.isShowDiscountDetailsModal && this.state.selectedDisc &&
            <Modal
              title={translate("discount.detailsTitle")}
              footer={null}
              onCancel={() => this.closePromoDetails()}
              centered
              width={1300}
              closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
              visible={this.props.discounts.isShowDiscountDetailsModal}
              className="discount-modal"
              maskClosable={false}
            >
              <DiscountDetails selectedDisc={this.state.selectedDisc} />
            </Modal>
          }
        </React.Fragment>
      )
    }
    else {
      return (
        <div className="container pt-2">
          <NoData NoDataMessage={translate("discount.noData.discountList")} />
        </div>
      );
    }
  }

  render() { return (this.renderComp()) }
}

const mapStateToProps = (state) => {
  return {
    discounts: state.discounts,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        getProductDiscounts,
        openOrCloseDiscountDetailsModal
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountList);